import { v4 as uuidv4 } from 'uuid';
import img1  from '../../assets/img/home2/S1.jpeg';
import img2  from '../../assets/img/home2/S2.jpeg';
import img3  from '../../assets/img/home2/S3.jpeg';
import img4  from '../../assets/img/home2/S4.jpeg';
import img5  from '../../assets/img/home2/S5.jpeg';
import img6  from '../../assets/img/home2/S6.jpeg';
import img7  from '../../assets/img/home2/S7.jpeg';
import img8  from '../../assets/img/home2/S8.jpeg';
import img9  from '../../assets/img/home2/S9.jpeg';
import img10 from '../../assets/img/home2/S10.jpeg';
import img11 from '../../assets/img/home2/S11.jpeg';
import img12 from '../../assets/img/home2/S12.jpeg';
import img13 from '../../assets/img/home2/S13.jpeg';
import img14 from '../../assets/img/home2/S14.jpeg';
import img15 from '../../assets/img/home2/S15.jpeg';
import img16 from '../../assets/img/home2/S16.jpeg';



const servicesTwoData = [
  // ROW 1
  {
    id: uuidv4(),
    img: img1,
    title: 'General AC Service',
    desc: 'Reliable General AC Service in the UAE with complete inspection, filter cleaning, and cooling performance testing for homes and offices. Dhtech provides same-day AC servicing across the UAE to improve efficiency, reduce electricity bills, and prevent breakdowns.',
  },
  {
    id: uuidv4(),
    img: img2,
    title: 'AC Repairs',
    desc: 'Need urgent AC repair in UAE for weak cooling, water leakage, or sudden breakdown? Dhtech offers fast and affordable AC repair services near you with expert diagnosis and guaranteed solutions.',
  },
  {
    id: uuidv4(),
    img: img3,
    title: 'AC Duct Cleaning',
    desc: 'Professional AC duct cleaning in UAE removes dust, mold, and allergens to improve indoor air quality and airflow. Our advanced duct cleaning service ensures healthier air and energy-efficient cooling performance.',
  },
  {
    id: uuidv4(),
    img: img4,
    title: 'AC Deep Cleaning',
    desc: 'Book expert AC deep cleaning in UAE to eliminate bacteria, bad odors, and heavy dirt buildup inside your unit. Dhtech uses chemical cleaning methods to restore powerful cooling and extend AC lifespan.',
  },

  // ROW 2
  {
    id: uuidv4(),
    img: img5,
    title: 'AC Coil Cleaning',
    desc: 'Our AC coil cleaning service in UAE enhances cooling efficiency by removing dirt from evaporator and condenser coils. Clean coils help lower power consumption and prevent compressor damage.',
  },
  {
    id: uuidv4(),
    img: img6,
    title: 'Annual Maintenance Contract (AMC)',
    desc: 'Protect your system with a trusted AC Annual Maintenance Contract (AMC) in UAE including scheduled servicing and priority emergency support. Dhtech’s preventive maintenance plans help avoid unexpected breakdowns and costly repairs.',
  },
  {
    id: uuidv4(),
    img: img7,
    title: 'Split AC Installation',
    desc: 'Looking for professional Split AC installation in UAE with proper mounting and refrigerant charging? Dhtech ensures safe installation, maximum cooling performance, and long-term reliability.',
  },
  {
    id: uuidv4(),
    img: img8,
    title: 'Centralized HVAC Systems',
    desc: 'We specialize in installation and maintenance of Centralized HVAC systems in UAE for residential towers, villas, and commercial buildings. Our certified HVAC experts deliver energy-efficient climate control solutions built for extreme weather conditions.',
  },

  // ROW 3
  {
    id: uuidv4(),
    img: img9,
    title: 'Ducted Split Systems',
    desc: 'Expert Ducted Split AC installation and servicing in UAE for seamless cooling distribution in large spaces. Dhtech provides professional setup, testing, and maintenance for long-lasting performance.',
  },
  {
    id: uuidv4(),
    img: img10,
    title: 'Package Units',
    desc: 'Get professional installation and servicing for HVAC package units in UAE designed for warehouses, factories, and commercial properties. Our technicians ensure optimal airflow, efficiency, and system durability.',
  },
  {
    id: uuidv4(),
    img: img11,
    title: 'VRF / VRV Systems',
    desc: 'Professional VRF/VRV system installation and maintenance in UAE for advanced multi-zone cooling solutions. Dhtech delivers energy-saving HVAC technology for offices, hotels, and high-end residential projects.',
  },
  {
    id: uuidv4(),
    img: img12,
    title: 'Chilled Water FCU Installation',
    desc: 'We provide expert Chilled Water FCU installation in UAE with proper balancing and performance testing. Our experienced HVAC team ensures efficient cooling for commercial and large-scale properties.',
  },

  // ROW 4
  {
    id: uuidv4(),
    img: img13,
    title: 'Fresh Air & Ventilation Systems',
    desc: 'Improve air quality with professional Fresh Air and Ventilation system installation in UAE. Dhtech designs and installs ventilation solutions that ensure proper airflow and compliance with safety standards.',
  },
  {
    id: uuidv4(),
    img: img14,
    title: 'AC Gas Top-Up / Refrigerant Refill',
    desc: 'Experiencing low cooling? Book AC gas top-up in UAE with leak detection and safe refrigerant refill services. Dhtech ensures correct gas pressure for maximum cooling efficiency and system protection.',
  },
  {
    id: uuidv4(),
    img: img15,
    title: 'AC Drain Line & Water Leakage Service',
    desc: 'Stop AC water leakage quickly with our AC drain line cleaning service in UAE. Our experts clear blockages, prevent mold growth, and protect your property from water damage.',
  },
  {
    id: uuidv4(),
    img: img16,
    title: 'AC Electrical & Thermostat Check',
    desc: 'Ensure safe operation with our AC electrical and thermostat check service in UAE. Dhtech inspects wiring, capacitors, and thermostat calibration to prevent failures and improve performance.',
  },
];

export default servicesTwoData;
